import { createFileRoute } from '@tanstack/react-router'
import { ClinicEditorPage } from '@/features/clinics/editor'

export const Route = createFileRoute('/clinics_/new')({
  component: ClinicEditorPage,
})
